import { Link } from "react-router-dom";
import { PiHeartThin } from "react-icons/pi";
import AccountLayout from "./AccountLayout";
import { useWishlist, useToggleWishlist } from "../libs/useWishlist";
import { getProductUrl } from "../libs/getProductUrl";
import { toast } from "react-toastify";
import { AccountGridSkeleton } from "./AccountSkeletons";
import ProductPriceDisplay from "../components/ProductPriceDisplay";
import "../components/ProductCard.css";
import "./UserProfile.css";

const PLACEHOLDER = "https://via.placeholder.com/200x200?text=No+Image";

const Customersaveditem = () => {
  const { data: items = [], isLoading } = useWishlist();
  const { mutate: toggleWishlist } = useToggleWishlist();

  const handleRemove = (productId) => {
    toggleWishlist(
      { productId, saved: true },
      {
        onSuccess: () => toast.success("Removed from saved items"),
        onError: () => toast.error("Could not remove item"),
      }
    );
  };

  return (
    <AccountLayout title={isLoading ? undefined : "Saved Items"} loading={isLoading}>
      {isLoading ? (
        <AccountGridSkeleton count={6} />
      ) : (
        <>
          {items.length === 0 && (
            <div className="account-empty">
              <div className="account-empty__icon">
                <PiHeartThin />
              </div>
              <h3>You have no saved items yet</h3>
              <p>Tap the heart on products you like to save them here.</p>
              <Link to="/market" className="account-btn account-btn--secondary">
                Start shopping
              </Link>
            </div>
          )}
          <div className="saved-products-grid">
            {items.map(({ product, _id }) =>
              product ? (
                <div key={_id} className="saved-product-card">
                  <Link to={getProductUrl(product)}>
                    <img src={product.images?.[0] || PLACEHOLDER} alt={product.name} />
                    <p>{product.name}</p>
                    <ProductPriceDisplay product={product} size="card" />
                  </Link>
                  <button type="button" onClick={() => handleRemove(product._id)}>
                    Remove
                  </button>
                </div>
              ) : null
            )}
          </div>
        </>
      )}
    </AccountLayout>
  );
};

export default Customersaveditem;
